var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.time !== 0 ? _c('div', [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v("Lock Time")]), _vm.isUnlocked ? _c('div', [_vm._v(" Unlocked since " + _vm._s(_vm.date.toLocaleString()) + " (" + _vm._s(_vm._f("fromNow")(_vm.time * 1000)) + ") ")]) : _c('div', [_vm._v(" Output can be spent " + _vm._s(_vm._f("fromNow")(_vm.time * 1000)) + " (" + _vm._s(_vm.date.toLocaleString()) + ") ")])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }